import ContactForm from "@/components/ContactForm";
import PageHero from "@/components/PageHero";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/site";

export default function QuotePage() {
  return (
    <div data-testid="quote-page">
      <PageHero
        eyebrow="Request a Quote"
        title="Tell us about your project."
        subtitle="Share a few details and we'll come back with a clear scope and a realistic estimate."
      />

      <section className="py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-6" data-testid="quote-side-panel">
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-3">How it works</div>
              <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0A1A36]">
                A simple, transparent process.
              </h2>
            </div>
            <ol className="space-y-5">
              {[
                { n: "01", t: "Share your brief", b: "Use the form, email, or call us with project details." },
                { n: "02", t: "Site review & scoping", b: "We discuss requirements and arrange a site visit if needed." },
                { n: "03", t: "Quote & programme", b: "We deliver a clear cost estimate with a realistic timeline." },
              ].map((step) => (
                <li key={step.n} className="flex gap-5 border-l-2 border-[#D4AF37] pl-5">
                  <div className="font-mono text-xs text-[#D4AF37] pt-1">{step.n}</div>
                  <div>
                    <div className="font-display font-bold text-lg text-[#0A1A36]">{step.t}</div>
                    <p className="text-sm text-slate-600 mt-1">{step.b}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="bg-[#0A1A36] text-white p-7 mt-8">
              <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-3">Prefer to talk directly?</div>
              <div className="space-y-2 text-sm">
                <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-2 hover:text-[#D4AF37]" data-testid="quote-phone">
                  <Phone className="h-4 w-4 text-[#D4AF37]" /> {COMPANY.phone}
                </a>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-[#D4AF37] break-all" data-testid="quote-email">
                  <Mail className="h-4 w-4 text-[#D4AF37]" /> {COMPANY.email}
                </a>
                <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5" /> {COMPANY.address}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-white border border-[#E2E8F0] p-6 sm:p-10">
              <ContactForm defaultService="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
